/// <amd-module name="Search/Wiki/Flux/Stores/SearchStore" />

//import * as VSSStore from "VSS/Reflux/Store";
import * as BaseSearchStore from "Search/Shared/Base/Stores/SearchStore2";

import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub2";
import { areQueriesEqual } from "Search/Wiki/WikiUtils";
import { WikiSearchResponse, WikiSearchRequest, WikiResult } from "Search/WebApi/Contracts/Search.Shared";

export class SearchStore extends BaseSearchStore.SearchStore<WikiSearchRequest, WikiSearchResponse, WikiResult> {
    protected areCorrectResultsLoaded(request: WikiSearchRequest, payload: IResultsLoadedPayload<WikiSearchRequest, WikiSearchResponse, WikiResult>): boolean {
        request.$top = payload.request.$top;
        return areQueriesEqual(request, payload.request);
    }

    public areQueriesSame = (request: WikiSearchRequest, requestInPayload: WikiSearchRequest): boolean => {
        return areQueriesEqual(request, requestInPayload);
    }

    public getUpdatedResponse = (responseInPayload: WikiSearchResponse): WikiSearchResponse => {
        const { response, fetchMoreScenario } = this._state;
        if (!fetchMoreScenario || !response) {
            return responseInPayload;
        }

        response.results.push(...responseInPayload.results);
        return response;
    }
}
